"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _isArray = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/array/is-array"));
var _react = _interopRequireDefault(require("react"));
/** useResizeObserver hook based on modified version of https://github.com/ZeeCoder/use-resize-observer */

function useResizeObserver() {
  let opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  // `defaultRef` Has to be non-conditionally declared here whether or not it'll
  // be used as that's how hooks work.
  // @see https://reactjs.org/docs/hooks-rules.html#explanation
  const defaultRef = _react.default.useRef(null);

  // Saving the callback as a ref. With this, I don't need to put onResize in the
  // effect dep array, and just passing in an anonymous function without memoising
  // will not reinstantiate the hook's ResizeObserver
  const onResize = opts.onResize;
  const onResizeRef = _react.default.useRef(undefined);
  onResizeRef.current = onResize;

  // Using a single instance throughought the hook's lifetime
  const resizeObserverRef = _react.default.useRef();
  const ref = opts.ref || defaultRef;
  const [size, setSize] = _react.default.useState({
    width: undefined,
    height: undefined,
    top: undefined,
    left: undefined
  });

  // Using a ref to track the previous width / height to avoid unnecessary renders
  const previous = _react.default.useRef({
    width: undefined,
    height: undefined,
    top: undefined,
    left: undefined
  });
  const requestRef = _react.default.useRef();
  _react.default.useEffect(() => {
    if (resizeObserverRef.current) {
      return;
    }
    if (window && window.ResizeObserver) {
      resizeObserverRef.current = new ResizeObserver(entries => {
        requestRef.current = requestAnimationFrame(() => {
          if (!(0, _isArray.default)(entries)) {
            return;
          }

          // Since we only observe the one element, we don't need to loop over the
          // array
          if (!entries.length) {
            return;
          }
          const entry = entries[0];

          // `Math.round` is in line with how CSS resolves sub-pixel values
          const newWidth = Math.round(entry.contentRect.width);
          const newHeight = Math.round(entry.contentRect.height);
          const newTop = Math.round(entry.contentRect.top);
          const newLeft = Math.round(entry.contentRect.left);
          if (previous.current.width !== newWidth || previous.current.height !== newHeight || previous.current.top !== newTop || previous.current.left !== newLeft) {
            const newSize = {
              width: newWidth,
              height: newHeight,
              top: newTop,
              left: newLeft
            };
            if (onResizeRef.current) {
              onResizeRef.current(newSize);
            } else {
              previous.current.width = newWidth;
              previous.current.height = newHeight;
              previous.current.top = newTop;
              previous.current.left = newLeft;
              setSize(newSize);
            }
          }
        });
      });
    }
    return () => {
      if (requestRef && requestRef.current) {
        cancelAnimationFrame(requestRef.current);
      }
    };
  }, []);
  _react.default.useEffect(() => {
    if (typeof ref !== 'object' || ref === null || !(ref.current instanceof Element)) {
      return;
    }
    const element = ref.current;
    resizeObserverRef.current?.observe(element);
    return () => resizeObserverRef.current?.unobserve(element);
  }, [ref]);
  return _react.default.useMemo(() => ({
    ref,
    width: size.width,
    height: size.height,
    top: size.top,
    left: size.left
  }), [ref, size.width, size.height, size.top, size.left]);
}
var _default = exports.default = useResizeObserver;